'use client'

import {useEffect} from 'react'
import {getPerformanceMetrics} from '@app/analytics/events/performance-metrics'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'

const WebVital = () => {
  useEffect(() => {
    const collectPerformanceMetrics = async () => {
      try {
        const {metrics} = await getPerformanceMetrics()

        if (Object.keys(metrics).length > 0) {
          console.log('Performance metrics collected:', metrics)

          // Trigger analytics with web-vitals event
          triggerAnalytics('web-vitals', metrics).sendCollector()
        }
      } catch (error) {
        console.error('Failed to collect performance metrics:', error)
      }
    }

    collectPerformanceMetrics()
  }, [])

  return null
}

export default WebVital
